import DataMapper from './DataMapper'
import RepudiationGround from '../../models/RepudiationGround'
import RepudiationGroundRM from '../responsemodel/RepudiationGroundRM'

export default class RepudiationGroundDataMapper extends DataMapper<RepudiationGroundRM, RepudiationGround> {
  map = (rm: RepudiationGroundRM) => new RepudiationGround(rm.repudiation_ground, rm.point, rm._id)
}
